import { render, staticRenderFns } from "./VideoPlayerModal.vue?vue&type=template&id=1b77ffc8&scoped=true"
import script from "./VideoPlayerModal.vue?vue&type=script&lang=js"
export * from "./VideoPlayerModal.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerModal.vue?vue&type=style&index=0&id=1b77ffc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b77ffc8",
  null
  
)

export default component.exports